export default {
    COLLAPSED: 'SIDEBAR_COLLAPSED',
};